import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import img from '../Assets/Group 181.png'
import hios from '../Assets/history.png'
import step from '../Assets/step.png'
function About() {
  return (
    <>
        <Navbar/>
        <div className='AboutUs-banner'>
        <h3>About Us</h3>
        <p>Discover Our Story: Learn More About Who We Are</p>

        </div>
        <div className='about-company'>
                <div className='about-company-left'>
                <p>ABOUT US</p>
                <h3>Choose the best Semiconductor company</h3>
            
        </div>
            <div className='about-company-right'>
            <p>Semicave semiconductor is emerging as a leader in providing engineering solutions worldwide.
We offer end-to-end Semiconductor, Embedded, Automotive and System Design to design and build next-generation leadership products under one roof. And allowing clients to achieve both quick wins and long-term results.
Our goal is to be an extended arm of engineering product and IT companies and ensure good quality productization cost-effectively.</p>
        </div>
        </div>
        <div className='about-img'>
<img src={img}/>
        </div>
    <br/>
    <br/>

        <div className='mission-vision'>
            <div className='services-heading'>
<p>Mission & Vision</p>
<h3>Our Mission & Vision</h3>
    </div>
    <br/>
    <br/>
    <br/>

    <br/>
    <div className='mission-vision-boxs'>
  <div className='mission-vision-box'>
  <div className='mission-btn'>
<p>Mission</p>
  </div>
    <br/>
    <br/>
    <br/>

<h3>Empowering Innovation and Sustainability for a Better Tomorrow</h3>
<p>Empower individuals and organizations to achieve their full potential by providing innovative technology solutions, exceptional customer service, and a commitment to sustainability. We embrace the power of change to create value and shared success for our clients, people, shareholders, partners, and communities.</p>
    </div>
    <div className='mission-vision-box'>
  <div className='mission-btn'>
<p>Vision</p>
  </div>
    <br/>
    <br/>
    <br/>

<h3>Empowering Innovation and Sustainability for a Better Tomorrow</h3>
<p>Empower individuals and organizations to achieve their full potential by providing innovative technology solutions, exceptional customer service, and a commitment to sustainability. We embrace the power of change to create value and shared success for our clients, people, shareholders, partners, and communities.</p>
    </div>
    </div>
        </div>
        {/* <div className='history-div'>
           <div className='services-heading'>
<p>History</p>
<h3>Our History</h3>
    </div>
    <img src={step}/>
        </div>
        <div className='history'>
   <div className='history-box'>
  <div className='history-box-left'>
  <h3>Fueling Industries & Innovation</h3>
  <p>Empower individuals and organizations to achieve their full potential by providing innovative technology solutions, exceptional customer service, and a commitment to sustainability. We embrace the power of change to create value and shared success for our clients, people, shareholders, partners, and communities.</p>

        </div>
          <div className='history-box-right'>
<img src={hios}/>
        </div>
        </div>
        </div> */}
        <Footer/>
    </>
  )
}

export default About